import { identity } from 'ramda'
import * as React from 'react'

interface GridTabsArguments {
  selectedTab: string
  setSelectedTab: (tab: string) => void
}

const GridTabsContext = React.createContext<GridTabsArguments>({
  selectedTab: '',
  setSelectedTab: identity,
})

export function useGridTabsContext() {
  const context = React.use(GridTabsContext)
  if (!context) {
    throw new Error(
      'Attempted to access tabs context before initializing it, please use GridTabsProvider to initialize the context.',
    )
  }
  return context
}

export function GridTabsProvider({ children }: React.PropsWithChildren) {
  const [selectedTab, setSelectedTab] = React.useState<string>('')

  const value = React.useMemo(() => ({ selectedTab, setSelectedTab }), [selectedTab])

  return <GridTabsContext value={value}>{children}</GridTabsContext>
}
